// Cart Drawer For Upsell Products
$(document).ready(function () {
  $("[data-ajax-cart-trigger]").on("click", function () {
    $(".cartUpsellContainer").show();
    let upSellSliderElements = document.querySelectorAll(".cartUpsellContainer .cartUpsellProdBox");
    upSellSliderElements.forEach(function (upSellSliderElement) {
      if (
        upSellSliderElement &&
        !$(upSellSliderElement).hasClass("flickity-enabled")
      ) {
        let upSellSlider = new Flickity(upSellSliderElement, {
          accessibility: true,
          resize: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: true,
          percentPosition: true,
          setGallerySize: true,
          cellAlign: 'left'
        });

        upSellSlider.on('settle', function () {
          upSellSlider.resize();
        });

        setTimeout(function () {
          upSellSlider.resize();
        }, 500);
      }
    });
  });
});
// Cart Drawer For Upsell Products - End

// Product Card ATC Button Variant Select - Start
(function () {
  function getCard(el) {
    return el.closest('.product-wrap') || el.closest('.product__thumbnail') || el.closest('.thumbnail') || el.closest('[data-load-more--grid-item]') || el.closest('.column') || null;
  }

  function hasSwatches(card) {
    return !!card && !!card.querySelector('.thumbnail-swatch .swatch');
  }

  function swapImgSrc(imgEl, url) {
    if (!imgEl || !url) return;

    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('sizes');

    if (imgEl.dataset) {
      if (imgEl.dataset.srcset) imgEl.dataset.srcset = '';
      if (imgEl.dataset.src)    imgEl.dataset.src = '';
      if (imgEl.dataset.sizes)  imgEl.dataset.sizes = '';
    }

    imgEl.setAttribute('src', url);

    var picture = imgEl.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach(function (s) {
        if (s.dataset && s.dataset.srcset) s.dataset.srcset = '';
        s.removeAttribute('srcset');
      });
    }
  }

  // ✅ Only enforce "Select option" when swatches actually exist
  function applyNoSelectionState(card) {
    if (!card || !hasSwatches(card)) return;

    card.querySelectorAll('.thumbnail-swatch .swatch.is-active').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });

    var idInput = card.querySelector('form[data-product-form] .js-variant-id');
    if (idInput) idInput.value = '';

    var atc = card.querySelector('.js-atc');
    if (atc) {
      atc.disabled = true;
      atc.classList.remove('sold');
      if (atc.tagName === 'INPUT') {
        atc.value = 'Select option';
      }
    }
  }

  function updateCardForSwatch(card, swatch) {
    if (!card || !swatch) return;

    var variantId = swatch.getAttribute('data-variant-id') || '';
    var available = (swatch.getAttribute('data-available') === 'true');

    // 1) hidden variant id
    var idInput = card.querySelector('form[data-product-form] .js-variant-id');
    if (idInput && variantId) idInput.value = variantId;

    // 2) active visual (and aria)
    card.querySelectorAll('.thumbnail-swatch .swatch').forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    // 3) ATC state
    var atc = card.querySelector('.js-atc');
    if (atc) {
      atc.disabled = !available;
      if (atc.tagName === 'INPUT') atc.value = available ? 'Add to Cart' : 'Sold out';
      atc.classList.toggle('sold', !available);
    }

    // 4) image swap (robust)
    var newImg = swatch.getAttribute('data-image');
    if (newImg) {
      var primary = card.querySelector('.product__imageContainer img:not(.secondary)') || card.querySelector('.product__imageContainer picture img') || card.querySelector('.product__imageContainer img');

      if (primary) swapImgSrc(primary, newImg);

      var flktyEl = card.querySelector('[data-product-gallery]');
      if (flktyEl && flktyEl._flickity) {
        try { flktyEl._flickity.select(0); } catch (e) {}
      }
    }
  }

  // ✅ If no swatches: keep the form ready to submit with existing hidden id
  function initDefaults() {
    document.querySelectorAll('.product-wrap, .product__thumbnail, .thumbnail').forEach(function (card) {
      if (hasSwatches(card)) {
        var active = card.querySelector('.thumbnail-swatch .swatch.is-active');
        if (active) {
          updateCardForSwatch(card, active);
        } else {
          applyNoSelectionState(card);
        }
      } else {
        // No swatches → single variant / simple product
        var idInput = card.querySelector('form[data-product-form] .js-variant-id');
        var atc = card.querySelector('.js-atc');

        // Hidden input should already be set by Liquid:
        // <input type="hidden" name="id" value="{{ product.variants.first.id }}" class="js-variant-id"/>
        // Safety fallback (optional): try data attribute if you added it on wrapper
        if (idInput && !idInput.value) {
          var fallback = card.getAttribute('data-first-variant-id');
          if (fallback) idInput.value = fallback;
        }

        if (atc) {
          // Don't override sold-out UI
          var isSold = atc.classList.contains('sold') || atc.value === 'Sold out';
          if (!isSold) {
            atc.disabled = false;
            atc.classList.remove('sold');
            if (atc.tagName === 'INPUT') atc.value = 'Add to Cart';
          }
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDefaults();

    document.body.addEventListener('click', function (e) {
      var sw = e.target.closest('.thumbnail-swatch .swatch');
      if (!sw) return;
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();

      var card = getCard(sw);
      updateCardForSwatch(card, sw);
      return false;
    }, true);
  });
})();
// Product Card ATC Button Variant Select - End


// about us page 2 image transition logic start
document.addEventListener("DOMContentLoaded", function() {
  const imageItems = document.querySelectorAll(".about-2bglass .multi-image-column .image-item");
  imageItems.forEach(item => {
    item.addEventListener("click", () => {
      // reset all images
      imageItems.forEach(i => i.classList.remove("active"));
      // set clicked image on top
      item.classList.add("active");
    });
  });
});
// about us page 2 image transition logic end

// search icon logic
$('.new_search_form .submit-search').on('click touchstart', function (e) {
  $(this).parents('form').submit();
});